import { render, staticRenderFns } from "./orderDistribution.vue?vue&type=template&id=081606c4&scoped=true&"
import script from "./orderDistribution.vue?vue&type=script&lang=js&"
export * from "./orderDistribution.vue?vue&type=script&lang=js&"
import style0 from "./orderDistribution.vue?vue&type=style&index=0&id=081606c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081606c4",
  null
  
)

export default component.exports